export default "__VITE_ASSET__BJIVnBGk__"